import config from "utils/config";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
  ApolloLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

const AUTH_TOKEN_KEY = "@lookme::authToken";

const httpLink = createHttpLink({
  uri: config.get("GRAPHQL_URL"),
});

const authLink = setContext((_, { headers }) => {
  // const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const token = config.get("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      console.error(`GraphQL error:`, error);
    });
  }

  if (networkError) {
    console.error(`Network error: ${networkError}`);
  }
});

const cache = new InMemoryCache();

export const createApolloClient = (): ApolloClient<NormalizedCacheObject> => {
  try {
    return new ApolloClient({
      link: ApolloLink.from([errorLink, authLink, httpLink]),
      credentials: "include",
      cache,
    });
  } catch (error) {
    console.error("Error creating Apollo client:", error);
    throw error;
  }
};

const client = createApolloClient();

export { default as builder } from "./builder";
export default client;

// import config from "utils/config";

// import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
// import { setContext } from "@apollo/client/link/context";
// // import helper from "utils/helper";
// const httpLink = createHttpLink({
//   uri: config.get("GRAPHQL_URL"),
// });

// export const createApolloClient = (authToken: string) => {
//   const authLink = setContext((_, { headers }) => {
//     // const token = config.get("token") || authToken;
//     const token = localStorage.getItem("@lookme::authToken") || authToken;
//     // console.log("token khi khởi tạo createApolloClient", token);
//     return {
//       headers: {
//         ...headers,
//         authorization: token ? `Bearer ${token}` : undefined,
//       },
//     };
//   });
//   try {
//     return new ApolloClient({
//       link: authLink.concat(httpLink),
//       credentials: "include",
//       cache: new InMemoryCache(),
//     });
//   } catch (error) {
//     console.error("Error creating Apollo client:", error);
//     throw error;
//   }
// };
// const client = createApolloClient("");
// export { default as builder } from "./builder";
// export default client;
